<template>
<div id="app">
  <Forum v-if="$route.query.showforum" />
  <Thread v-else-if="$route.query.showtopic" />
  <Members v-else-if="$route.query.act && $route.query.act == 'Members'" />
  <AllForums v-else />
</div>
</template>

<script>
import Forum from './components/Forum'
import AllForums from './components/AllForums'
import Thread from './components/Thread'
import Members from './components/Members'

export default {
  components: {
    Forum,
    AllForums,
    Thread,
    Members
  }
}
</script>

<style lang="scss">
@import "./App.scss";
</style>
